<template>
  <div class="answers">
    <div
      v-for="(transport, index) in transportsList"
      v-bind:key="index"
      v-on:click="clicked(transport)"
      v-bind:class="{ active: transport.isActive }"
      class="age-button"
    >
      {{ transport.title }}
      <img width="70" :src="imgStep(index)" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      transportImg: ['icon-car.svg', 'icon-subway.svg', 'icon-bike.svg', 'icon-walk.svg'],
    };
  },
  computed: {
    transportsList() {
      return this.$store.getters.transportsList;
    },
  },
  methods: {
    imgStep(index) {
      return require('../../../assets/' + this.transportImg[index]);
    },
    clicked(transport) {
      transport.isActive = !transport.isActive;
    },

    getActive(index) {
      return this.$store.getters.getMonoCheck(this.step) === index;
    },
  },
  name: 'TransportsStep',
};
</script>

<style scoped>
.age-button {
  padding: 1em;
  background: white;
  margin-right: 2%;
  cursor: pointer;
  white-space: nowrap;
  font-size: 1.8vw;
  display: flex;
  min-width: 20%;
  flex-direction: column;
  align-items: center;
}
.age-button > img {
  opacity: 0.8;
  margin-top: 10px;
  font-weight: lighter;
}
.answers {
  margin-top: 10px;
  display: flex;
}
.active > img {
  filter: brightness(0) invert(1);
}
.age-button:hover > img {
  filter: brightness(0) invert(1);
}
.active.active.active, /* Force .active priority */
.age-button:hover {
  background-color: #5e6a71;
  color: white;
}
.age-button:hover {
  background-color: #afb1a1;
}
</style>
